import { getStore } from '@/util/store'
//消息管理
export const newsListOption = (safe) => {
	return {
		card: true,
		stripe: true,
		border: true,
		align: 'center',
		menuAlign: 'center',
		searchMenuPosition: 'right',
		menuWidth: 140,
		gutter: 20,
		searchMenuSpan: 6,
		labelWidth: 120,
		// dialogWidth: '45%',
		column: [
			{
				label: '名称',
				prop: 'name',
				search: true,
				rules: [
					{
						required: true,
						message: '请输入名称',
						trigger: 'blur',
					},
				],
			},
		
			{
				label: '封面图片',
				prop: 'coverImage',
				fileType: 'img',
				type: 'upload',
				tip: '建议上传请上传865*377的图片或者宽高7:3的图片',
				listType: 'picture-img',
				action: '/dist/material/uploadFile',
				data: {
					type: 1,
				},
				accept: ['.png', '.jpeg', '.gif', '.jpg'],
			},
			{
				label: "生效时间",
				prop: "newsTime",
				type: "datetime",
				format: "yyyy-MM-dd HH:mm:ss",
				valueFormat: "yyyy-MM-dd HH:mm:ss",
				startPlaceholder: "发帖开始时间",
				endPlaceholder: "发帖结束时间",
				width: 160,
				hide: true,
				showColumn: false,
				search: true,
				searchRange: true,
			},

			{
				label: '持续时间',
				prop: 'showTime',
				formatter: ({ showTime }) => {
					return `${showTime}秒`
				},
				hide: true,
				editDisplay: false,
				addDisplay: false,
				value: 5,
			},

			{
				label: '状态',
				prop: 'type',
				type: 'select',
				search: true,
				dicData: [
					{
						label: '上架',
						value: 1,
					},
					{
						label: '下架',
						value: 2,
					},
				],
				value: 1,
				rules: [
					{
						required: true,
						message: '请选择状态',
						trigger: 'blur',
					},
				],
			},

			{
				label: '推荐内容',
				formslot: true,
				prop: 'html',
				span: 24,
				rules: [
					{
						required: true,
						message: '请填充推荐内容',
						trigger: 'blur',
					},
				],
				hide: true,
				showColumn: false,
			},
			{
				label: '附件',
				formslot: true,
				prop: 'fileCollect',
				formatter: ({ fileCollect }) => {
					if (!fileCollect) {
						return ''
					}
					let files = JSON.parse(fileCollect).map((item) => item.name)
					//join换行符
					return files.join(' , ')
				},
			},
			{
				label: '排序',
				prop: 'sort',
				editDisplay: false,
				addDisplay: false,
				width: 180,
			},
			{
				label: '生效时间',
				prop: 'effectBegin',
				type: 'datetime',
				valueFormat: 'yyyy-MM-dd HH:mm:ss',
				rules: [
					{
						required: true,
						message: '请选择生效时间',
						trigger: 'blur',
					},
				],
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() + 24 * 60 * 60 * 1000 < Date.now()
					},
				},
			},
			{
				label: '失效时间',
				prop: 'effectEnd',
				type: 'datetime',
				valueFormat: 'yyyy-MM-dd HH:mm:ss',
				rules: [
					{
						required: true,
						message: '请选择失效时间',
						trigger: 'blur',
					},
				],
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() + 24 * 60 * 60 * 1000 < Date.now()
					},
				},
			},
			{
				label: '是否发布',
				prop: 'isPublish',
				addDisplay: false,
				editDisplay: false,
				html: true,
				formatter: ({ effectBegin = '', effectEnd = '' }) => {
					let currentTime = Date.now()
					if (new Date(effectBegin).getTime() <= currentTime && new Date(effectEnd).getTime() > currentTime) {
						return `<span style="color: red;font-weight: bold;">已发布</span>`
					}
					return '未发布'
				},

			},
			{
				label: '接收人角色',
				prop: 'suitRole',
				type: 'select',
				multiple: true,
				rules: [
					{
						required: true,
						message: '请选择接收人角色',
						trigger: 'blur',
					},
				],
				dicData: [
					{
						label: '主渠道',
						value: '4',
					},
					{
						label: '子渠道管理员',
						value: '5',
					},
					{
						label: '内勤',
						value: '6',
					},
				],
				span: 24,
				dataType: 'string',
			},
		],
	}
}

//公告管理
export const announcementManageOption = (safe) => {
	return {
		card: true,
		stripe: true,
		border: true,
		menuAlign: 'center',
		align: 'center',
		menuAlign: 'center',
		searchMenuPosition: 'right',
		// menuWidth: 140,
		gutter: 20,
		searchMenuSpan: 24,
		labelWidth: 120,
		// dialogWidth: '45%',
		column: [
			{
				label: '标题',
				prop: 'title',
				search: true,
				rules: [
					{
						required: true,
						message: '请输入标题',
						trigger: 'blur',
					},
				],
				span: 24,
			},

			{
				label: '公告类型',
				prop: 'type',
				type: 'select',
				rules: [
					{
						required: true,
						message: '请选择公告类型',
						trigger: 'blur',
					},
				],
				search: true,
				value: 1,

				dicData: [
					{
						label: '常规',
						value: '1',
					},
					{
						label: '费率',
						value: '2',
					},
				],
				span: 24,
				dataType: 'string',
				control: (val) => {
					let controlR = {}
					if (val == 1) {
						controlR.bannerImage = {
							display: true,
						}
						controlR.content = {
							display: true,
						}
						controlR.suitInsureTypes = {
							display: true,
						}
						controlR.extrasData = {
							display: false,
						}
					} else {
						controlR.bannerImage = {
							display: false,
						}
						controlR.content = {
							display: false,
						}
						controlR.suitInsureTypes = {
							display: false,
						}
						controlR.extrasData = {
							display: true,
						}
					}

					return controlR
				},
			},
			{
				label: '费率产品配置',
				prop: 'extrasData',
				formslot: true,
				hide: false,
				showColumn: false,
				display: false,
				span: 24,
			},

			{
				label: '文章描述',
				prop: 'description',
				type: 'textarea',
				span: 24,
				minRows: 2,
				rules: [
				
					{ max: 1000, message: '长度在 1000 个字符内', trigger: 'blur' },
				],
			},
			{
				label: '图片',
				prop: 'bannerImage',
				fileType: 'img',
				display: false,
				type: 'upload',
				tip: '建议上传请上传865*377的图片或者宽高7:3的图片',
				listType: 'picture-img',
				action: '/dist/material/uploadFile',
				data: {
					type: 1,
				},
				accept: ['.png', '.jpeg', '.gif', '.jpg'],
			},

			{
				label: '文章内容',
				formslot: true,
				display: false,
				prop: 'content',
				span: 24,
				rules: [
					{
						required: true,
						message: '请填充文章内容',
						trigger: 'blur',
					},
				],
				hide: true,
				showColumn: false,
			},
			{
				label: '关联产品',
				prop: 'suitProductIds',
				type: 'select',
				filterable: true,
				multiple: true,
				dataType: 'string',
				tip: '提示：关联产品为空时，全部渠道可见',
				labelTip: '提示：关联产品为空时，全部渠道可见',
				span: 24,
				dicUrl: `/dist/distProduct/listInfoAll`,
				props: {
					label: 'title',
					value: 'id',
				},
			},
			{
				label: '接收人角色',
				prop: 'roles',
				type: 'select',
				multiple: true,
				rules: [
					{
						required: true,
						message: '请选择接收人角色',
						trigger: 'blur',
					},
				],
				dicData: [
					{
						label: '主渠道',
						value: '4',
					},
					{
						label: '子渠道管理员',
						value: '5',
					},
					{
						label: '内勤',
						value: '6',
					},
				],
				span: 24,
				dataType: 'string',
			},
			{
				label: '排序',
				prop: 'sort',
				value: 0,
				placeholder: '越大越再前',
			},
			{
				label: '状态',
				prop: 'status',
				type: 'select',
				dicData: [
					{
						label: '上架',
						value: 1,
					},
					{
						label: '下架',
						value: 0,
					},
				],
				value: 1,
				rules: [
					{
						required: true,
						message: '请选择状态',
						trigger: 'blur',
					},
				],
			},
		],
	}
}
